/**
 * Gets the PAYROLLSERVICES_HOST variable from the BE to tell where the requests need to go
 * @returns {string} PAYROLLSERVICES_HOST variable set on `window` object
 */
export function getPayrollServicesHost(): string {
	return window.PAYROLLSERVICES_HOST;
}
